import { render, staticRenderFns } from "./actResultPage.vue?vue&type=template&id=e02ec4ba&scoped=true"
import script from "./actResultPage.vue?vue&type=script&lang=js"
export * from "./actResultPage.vue?vue&type=script&lang=js"
import style0 from "./actResultPage.vue?vue&type=style&index=0&id=e02ec4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02ec4ba",
  null
  
)

export default component.exports